<template>
  <td>
    <div class="table-fields">

      <div class="tr">
        <div class="td w-40">
          <i class="fa fa-check-square-o" v-if="attachmentsListIsEmpty(applicationAttachments)"></i>

          <div class="form-check form-check-inline mr-0" v-else>
            <input type="checkbox" class="form-check-input" :value="applicationId"
                   @change="$emit('selected-attachments-change', applicationId, isSelectedAttachments)"
                   v-model="isSelectedAttachments">
          </div>
        </div>

        <div class="td">
          <div class="table-fields"
               v-if="!attachmentsListIsEmpty(collectedOriginalAttachments) || !attachmentsListIsEmpty(collectedAttachments)">

            <template v-for="(attachments, type) in collectedOriginalAttachments">
              <template v-if="!originalAttachmentsInSelected && !collectedAttachments[type]">
                <div class="tr-header">
                  <div class="td w-40"></div>
                  <div class="td"><b>{{ type }}</b></div>
                </div>
                <del class="tr" v-for="attachment in attachments">
                  <div class="td w-40"></div>

                  <div class="td" :class="{'added': attachment['_added']}">
                    <a :href="attachment['link']" target="_blank">{{ attachment['name'] }}</a>
                    <i v-if="!attachment['valid']" class="fa fa-exclamation-triangle text-danger"
                       data-toggle="tooltip" data-placement="top" data-boundary="window"
                       :id="'tt' + attachment['id']" :data-container="'#tt' + attachment['id']"
                       title="This document appears to be corrupt or empty"></i>
                    <br/>
                    <small>Size: {{ bytesFormatted(attachment['size']) }}</small>
                    <small class="text-danger" v-if="attachment['error']">{{ attachment['error'] }}</small>
                  </div>
                </del>
              </template>
            </template>

            <template v-for="(attachments, type) in collectedAttachments">
              <div class="tr-header">
                <div class="td w-40"></div>
                <div class="td"><b>{{ type }}</b></div>
              </div>

              <del class="tr" v-for="originalAttachment in collectedOriginalAttachments[type]"
                   v-if="!originalAttachmentsInSelected">
                <div class="td w-40"></div>

                <div class="td" :class="{'added': originalAttachment['_added']}">
                  <a :href="originalAttachment['link']" target="_blank">{{ originalAttachment['name'] }}</a>
                  <i v-if="!originalAttachment['valid']" class="fa fa-exclamation-triangle text-danger"
                     data-toggle="tooltip" data-placement="top" data-boundary="window"
                     :id="'tt' + originalAttachment['id']" :data-container="'#tt' + originalAttachment['id']"
                     title="This document appears to be corrupt or empty"></i>
                  <br/>
                  <small>Size: {{ bytesFormatted(originalAttachment['size']) }}</small>
                  <small class="text-danger" v-if="originalAttachment['error']">
                    {{ originalAttachment['error'] }}
                  </small>
                </div>
              </del>

              <div class="tr" v-for="attachment in attachments">

                <div class="td w-40">
                  <div class="form-check form-check-inline mr-0">
                    <input type="checkbox" class="form-check-input"
                           @change="$emit('selected-attachments-item-change', attachment['id'], selectedAttachmentItems[attachment['id']])"
                           v-model="selectedAttachmentItems[attachment['id']]">
                  </div>
                </div>

                <div class="td" :class="{'added': attachment['_added']}">
                  <a :href="attachment['link']" target="_blank">{{ attachment['name'] }}</a>
                  <i v-if="!attachment['valid']" class="fa fa-exclamation-triangle text-danger"
                     data-toggle="tooltip" data-placement="top" data-boundary="window"
                     :id="'tt' + attachment['id']" :data-container="'#tt' + attachment['id']"
                     title="This document appears to be corrupt or empty"></i>
                  <br/>
                  <small>Size: {{ bytesFormatted(attachment['size']) }}</small>
                  <small class="text-danger" v-if="attachment['error']">{{ attachment['error'] }}</small>
                </div>
              </div>
            </template>
          </div>
          <div v-else>
            No attachments
          </div>
        </div>
      </div>
    </div>
  </td>

</template>

<script>

import ApplicationsMerge from "../../mixins/ApplicationsMerge";

export default {
  mixins: [ApplicationsMerge],

  emits: [
    'selected-attachments-change',
    'selected-attachments-item-change'
  ],

  props: {
    applicationId: {
      type: Number,
      required: true
    },

    applicationAttachments: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },

    collectedOriginalAttachments: {
      type: Object,
      required: true
    },

    collectedAttachments: {
      type: Object,
      required: true
    },

    originalAttachmentsInSelected: {
      type: Boolean,
      required: true
    },

    initialSelectedAttachmentItems: {
      type: Object,
      required: true
    },
  },

  data() {
    return {
      isSelectedAttachments: true,
      selectedAttachmentItems: {},
    };
  },

  watch: {

    initialSelectedAttachmentItems(data) {
      this.selectedAttachmentItems = Object.fromEntries(
        Object.keys(data).map(key => [key, this.selectedAttachmentItems[key] ?? true])
      );
    },
  },

}
</script>

<style scoped>

.w-40 {
  width: 40px;
}

.added {
  background-color: #c6ffc6;
}

.table-fields {
  display: table;
  width: 100%;
}

.tr-header {
  display: table-row;
  font-weight: bold;
}

.tr {
  display: table-row;
}

.td {
  display: table-cell;
  padding: 5px;
}

del, ins {
  padding: 2px 5px;
  border-radius: 5px;
}

</style>
